import axios from "@/plugins/axios.js";

export default {
  //New functions should ALWAYS come on top here for easy updates

  //last compare and update below.

  async getAllEmailsGroups() {
    const groups = await axios.getData(
      "/auth/get-all-emails-groups",

      localStorage.getItem("token")
    );
    return groups;
  },

  async saveNewEmailContactToGroup(emailName, emailAddress, groupID) {
    const contact = await axios.postDataWithToken(
      "/auth/save-new-email-contact",
      {
        emailName,
        emailAddress,
        groupID,
      },
      localStorage.getItem("token")
    );
    return contact;
  },
  async getSelectedEmailGroupMembers(groupName, groupID) {
    const members = await axios.postDataWithToken(
      "/auth/get-selected-email-group-members",
      {
        groupName,
        groupID,
      },
      localStorage.getItem("token")
    );
    return members;
  },
  async saveBulkEmailContacts(emailsDataArray) {
    const response = await axios.postDataWithToken(
      "/auth/save-bulk-email-contacts",
      {
        emailsDataArray,
      },
      localStorage.getItem("token")
    );
    return response;
  },
  determineEmailAddressesTable(groupTable) {
    let table = null;
    if (
      groupTable &&
      groupTable != "Staff" &&
      groupTable != "Clients" &&
      groupTable != "Users"
    ) {
      table = "email_addresses";
    } else {
      table = groupTable.toLowerCase();
    }
    return table;
  },
  isBuiltInTable(groupTable) {
    if (
      groupTable == "Staff" ||
      groupTable == "Clients" ||
      groupTable == "Users"
    ) {
      return true;
    } else {
      return false;
    }
  },
};
